import React, { useRef } from 'react';

import Navbar from './components/Navbar'
import Home from './components/Home'
import Footer from './components/Footer'

function App() {  
  // pass these refs to home component, so that they can be linked with the respective elements
  const servicesRef = useRef(null)
  const portfolioRef = useRef(null)
  const contactRef = useRef(null)

  // pass this function to navbar, called by navbar items
  const handleClick = (clickIndex) => {
    if(clickIndex === 1) {
      window.scroll(0, servicesRef.current.offsetTop - 30)
    }
    else if(clickIndex === 2) {
      window.scrollTo(0, portfolioRef.current.offsetTop - 30)
    }
    else if(clickIndex === 3) {
      window.scrollTo(0, contactRef.current.offsetTop - 30)
    } 
    else {

    }
  }

  return (
    <div className="App">
      <Navbar handler={handleClick} />
      <Home servicesRef={servicesRef} portfolioRef={portfolioRef} contactRef={contactRef}/>
      <Footer />
    </div>
  );
}

export default App;
